
<div class="page">
  <div class="container ourstory">
    <p class="pageTitle">Our Story</p>

    <!-- <p class="subtitle">
    Offering insights into your business operations through a user-friendly
    interface along with effortless customer engagement.
  </p> -->

    <div class="lineComp">
      <div class="outerCircle"><div class="innerCircle"></div></div>
      <div class="line line1"></div>
      <div class="outerCircle"><div class="innerCircle"></div></div>
      <div class="line line2"></div>
      <div class="outerCircle"><div class="innerCircle"></div></div>
    </div>

    <swiper
      style="
        --swiper-navigation-color: rgba(0, 0, 0, 0);
        --swiper-pagination-color: #fff;
      "
      loop="true"
      [navigation]="true"
      setWrapperSize="true"
      [autoplay]="{
        delay: 5000
      }"
      [breakpoints]="{
        '1300': {
          slidesPerView: 3,
          spaceBetween: 10
        },
        '769': {
          slidesPerView: 3,
          spaceBetween: 10
        },
        '450': {
          slidesPerView: 3,
          spaceBetween: 10
        },
        '0': {
          slidesPerView: 3,
          spaceBetween: 10,
          setWrapperSize: true
        }
      }"
      class="mySwiper1"
    >
      <div style="background-color: aqua" class="swiper-button-prev">
        <img
          src="../../../assets/images/newpartners/5e1adb8f67180-1578818447-w31DEumdRj 1.svg"
        />
      </div>
      <div class="swiper-button-next"></div>

      <ng-template swiperSlide>
        <p class="slideDate">December 2016</p>
        <p class="slideBody">
          The founders won a university competition with the aim of introducing
          a new idea in the digital banking sector which triggered the spark
          towards building their own startup
        </p>
      </ng-template>

      <ng-template swiperSlide>
        <p class="slideDate">May 2017</p>
        <p class="slideBody">
          With a team of just 5 people, out of the Greek Campus, Q-Less came to
          life with a vision for digitizing the education payment sector in
          Egypt
        </p>
      </ng-template>

      <ng-template swiperSlide>
        <p class="slideDate">November 2017</p>
        <p class="slideBody">First partnership built with Paymob</p>
      </ng-template>

      <ng-template swiperSlide>
        <p class="slideDate">April 2018</p>
        <p class="slideBody">
          Completed AUC Venture Lab fin-tech accelerator cycle 4
        </p>
      </ng-template>

      <ng-template swiperSlide>
        <p class="slideDate">April 2018</p>
        <p class="slideBody">Landed first merchant – LEAP nurseries</p>
      </ng-template>

      <ng-template swiperSlide>
        <p class="slideDate">November 2018</p>
        <p class="slideBody">Received first Angel Investment</p>
      </ng-template>

      <ng-template swiperSlide>
        <p class="slideDate">March 2020</p>
        <p class="slideBody">Q-Less was rebranded to Klickit</p>
      </ng-template>

      <ng-template swiperSlide>
        <p class="slideDate">May 2021</p>
        <p class="slideBody">
          Sealed the first Egyptian fintech deal with Ministry of Education (55k
          schools, 25M students)
        </p>
      </ng-template>

      <ng-template swiperSlide>
        <p class="slideDate">October 2021</p>
        <p class="slideBody">
          EFG Hermes and Camel Ventures joined Klickit’s family as Pre-Series A
          investors
        </p>
      </ng-template>

      <ng-template swiperSlide>
        <p class="slideDate">December 2021</p>
        <p class="slideBody">1M transactions processed</p>
      </ng-template>

      <ng-template swiperSlide>
        <p class="slideDate">March 2022</p>
        <p class="slideBody">Moved to new Office & Team expanded!</p>
      </ng-template>
    </swiper>

    <swiper
      style="
        --swiper-navigation-color: rgba(0, 0, 0, 0);
        --swiper-pagination-color: #fff;
      "
      [direction]="'vertical'"
      [navigation]="true"
      setWrapperSize="true"
      [autoplay]="{
        delay: 5000
      }"
      [breakpoints]="{
        '1300': {
          slidesPerView: 3,
          spaceBetween: 10
        },
        '769': {
          slidesPerView: 3,
          spaceBetween: 10
        },
        '450': {
          slidesPerView: 3,
          spaceBetween: 10
        },
        '0': {
          slidesPerView: 3,
          spaceBetween: 10,
          setWrapperSize: true
        }
      }"
      class="vertSlider"
    >
      <div style="background-color: aqua" class="swiper-button-prev">
        <img
          src="../../../assets/images/newpartners/5e1adb8f67180-1578818447-w31DEumdRj 1.svg"
        />
      </div>
      <div class="swiper-button-next"></div>

      <ng-template swiperSlide>
        <p class="slideDate">December 2016</p>
        <p class="slideBody">
          The founders won a university competition with the aim of introducing
          a new idea in the digital banking sector which triggered the spark
          towards building their own startup
        </p>
      </ng-template>

      <ng-template swiperSlide>
        <p class="slideDate">May 2017</p>
        <p class="slideBody">
          With a team of just 5 people, out of the Greek Campus, Q-Less came to
          life with a vision for digitizing the education payment sector in
          Egypt
        </p>
      </ng-template>

      <ng-template swiperSlide>
        <p class="slideDate">November 2017</p>
        <p class="slideBody">First partnership built with Paymob</p>
      </ng-template>

      <ng-template swiperSlide>
        <p class="slideDate">April 2018</p>
        <p class="slideBody">
          Completed AUC Venture Lab fin-tech accelerator cycle 4
        </p>
      </ng-template>

      <ng-template swiperSlide>
        <p class="slideDate">April 2018</p>
        <p class="slideBody">Landed first merchant – LEAP nurseries</p>
      </ng-template>

      <ng-template swiperSlide>
        <p class="slideDate">November 2018</p>
        <p class="slideBody">Received first Angel Investment</p>
      </ng-template>

      <ng-template swiperSlide>
        <p class="slideDate">March 2020</p>
        <p class="slideBody">Q-Less was rebranded to Klickit</p>
      </ng-template>

      <ng-template swiperSlide>
        <p class="slideDate">May 2021</p>
        <p class="slideBody">
          Sealed the first Egyptian fintech deal with Ministry of Education (55k
          schools, 25M students)
        </p>
      </ng-template>

      <ng-template swiperSlide>
        <p class="slideDate">October 2021</p>
        <p class="slideBody">
          EFG Hermes and Camel Ventures joined Klickit’s family as Pre-Series A
          investors
        </p>
      </ng-template>

      <ng-template swiperSlide>
        <p class="slideDate">December 2021</p>
        <p class="slideBody">1M transactions processed</p>
      </ng-template>

      <ng-template swiperSlide>
        <p class="slideDate">March 2022</p>
        <p class="slideBody">Moved to new Office & Team expanded!</p>
      </ng-template>
    </swiper>
  </div>

  <div class="lineC margTop container"></div>
  <div class="whatwedo">
    <p class="whatwedoTitle">What we do</p>

    <p class="whatwedoBody p1 container">
      Klickit offers a comprehensive payments & fees management solution
      tailored to accommodate various integrations enabling any institution to
      deploy their custom solution with our wide array of offerings of various
      payment methods. We offer an insight through our automated dashboards to
      deliver the required KPIs & metrics reaching the desired view of the data.
    </p>
  </div>

  <div class="ourComp container">
    <div class="our ourVision">
      <p class="ourTitle">Our <span style="color: '#5800BF'">Vision</span></p>

      <p class="ourBody p1">
        Klickit’s driver is a passion for facilitating people’s lives. whether
        it’s making school fees affordable for our end users or making the
        processing of payments simpler for our merchants, Klickit wants to be
        top of mind as far as educational payment services are concerned in the
        MEA region.
      </p>
    </div>

    <img class="swiggleWeb" src="../../../assets/images/swiggle.svg" />
    <img class="swiggleMob" src="../../../assets/images/swigglemob.svg" />

    <div class="our ourMission">
      <p class="ourTitle">Our <span style="color: '#5800BF'">Mission</span></p>

      <p class="ourBody p1">
        To make millions of stakeholders rely on Klickit as their partner for
        faster and hassle-free educational payments
      </p>
    </div>
  </div>

  <app-partners></app-partners>
  <div class="lineC container"></div>
  <div class="sampleImageab"></div>
</div>
